  document.addEventListener('DOMContentLoaded', function() {
    const chooseLinks = document.querySelectorAll('.ec-choose__title[href="#ec-pdp-details"]');
    
    chooseLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetElement = document.getElementById('ec-pdp-details');
        
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });

    const heightDropdowns = document.querySelectorAll('.ec-height-select');

    heightDropdowns.forEach(function (dropdown) {
      if (dropdown.closest('.ec-native-variant-chooser')) return;
      const trigger = dropdown.querySelector('.ec-height-select__trigger');
      const list = dropdown.querySelector('.ec-height-select__list');
      const options = dropdown.querySelectorAll('.ec-height-select__option');
      const hiddenInput = dropdown.querySelector('.ec-height-select__input');
      const labelElement = dropdown.querySelector('.ec-height-select__label');
      const defaultLabel = labelElement ? labelElement.textContent.trim() : '';

      if (!trigger || !list || !options.length) {
        return;
      }

      function closeHeightDropdown() {
        dropdown.classList.remove('ec-height-select--open');
        trigger.setAttribute('aria-expanded', 'false');
        if (dropdown.classList.contains('ec-height-select--in-accordion')) {
          const optionEl = dropdown.querySelector('.ec-pdp-choose-option');
          if (optionEl && optionEl.classList.contains('expanded') && typeof closeAccordion === 'function') {
            closeAccordion(optionEl);
          }
        }
      }

      function openHeightDropdown() {
        dropdown.classList.add('ec-height-select--open');
        trigger.setAttribute('aria-expanded', 'true');
        if (dropdown.classList.contains('ec-height-select--in-accordion')) {
          const content = dropdown.querySelector('.ec-pdp-choose-option__content');
          if (content && typeof refreshContentHeight === 'function') {
            requestAnimationFrame(function() { refreshContentHeight(content.closest('.ec-pdp-choose-option')); });
          }
        }
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (dropdown.classList.contains('ec-height-select--in-accordion')) {
          const optionEl = dropdown.querySelector('.ec-pdp-choose-option');
          if (optionEl && !optionEl.classList.contains('expanded') && typeof openAccordion === 'function') {
            openAccordion(optionEl);
          }
        }
        const isOpen = dropdown.classList.contains('ec-height-select--open');
        if (isOpen) {
          closeHeightDropdown();
        } else {
          openHeightDropdown();
        }
      });

      const customWrapper = dropdown.querySelector('.ec-height-select__custom-wrapper');
      const customInput = dropdown.querySelector('.ec-height-select__custom-input');
      const customHeightValue = dropdown.getAttribute('data-custom-height-value') || 'Custom Height (Specify in form)';

      function syncHeightToTarget(val) {
        const targetInputs = document.querySelectorAll('.ec-height-select__input-target');
        if (targetInputs && targetInputs.length) {
          targetInputs.forEach(function (t) { t.value = val || ''; });
        }
      }

      function syncVariantFromHeight(selectedValue) {
        if (!selectedValue) return;
        const productInfo = dropdown.closest('product-info');
        const sectionId = productInfo?.getAttribute('data-section') || productInfo?.dataset?.section || '';
        if (!sectionId) return;
        const scriptEl = document.getElementById('ec-product-variants-' + sectionId);
        if (!scriptEl) return;
        let heightIndex = parseInt(scriptEl.getAttribute('data-height-option-index'), 10);
        if (isNaN(heightIndex) || heightIndex < 0) {
          const singleOpt = scriptEl.getAttribute('data-single-option');
          if (singleOpt === '1') heightIndex = 0;
          else return;
        }
        let data;
        try {
          data = JSON.parse(scriptEl.textContent);
        } catch (e) { return; }
        if (!data.variantOptions || !data.variantOptions.length) return;
        const mainForm = productInfo.querySelector('#product-form-' + sectionId);
        const variantIdInput = (mainForm && mainForm.querySelector('input[name="id"]')) || document.querySelector('.product-variant-id, input[name="id"]');
        if (!variantIdInput) return;
        const currentId = parseInt(variantIdInput.value, 10);
        const currentVariant = data.variantOptions.find(function (v) { return v.id === currentId; });
        const optionKeys = ['option1', 'option2', 'option3'];
        const targetOptions = {};
        if (currentVariant) {
          optionKeys.forEach(function (k, i) {
            targetOptions[k] = (i === heightIndex) ? selectedValue : (currentVariant[k] || '');
          });
        } else {
          targetOptions[optionKeys[heightIndex]] = selectedValue;
          optionKeys.forEach(function (k, i) {
            if (i !== heightIndex) targetOptions[k] = targetOptions[k] || '';
          });
        }
        const match = data.variantOptions.find(function (v) {
          return optionKeys.every(function (k) {
            return (v[k] || '') === (targetOptions[k] || '');
          });
        });
        if (match && match.id !== currentId) {
          variantIdInput.value = match.id;
          variantIdInput.removeAttribute('disabled');
          variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          const productUrl = productInfo.dataset.url;
          if (productUrl && typeof fetch !== 'undefined') {
            const url = productUrl + (productUrl.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + match.id + '&section_id=' + sectionId;
            fetch(url).then(function (r) { return r.text(); }).then(function (htmlText) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(htmlText, 'text/html');
              const newProductInfo = doc.querySelector('product-info');
              if (!newProductInfo) return;
              const ids = ['price', 'Sku', 'Inventory', 'Volume', 'Price-Per-Item'];
              ids.forEach(function (id) {
                const src = doc.getElementById(id + '-' + sectionId);
                const dest = productInfo.querySelector('#' + id + '-' + sectionId);
                if (src && dest) dest.innerHTML = src.innerHTML;
              });
              const submitBtn = productInfo.querySelector('#ProductSubmitButton-' + sectionId);
              const newSubmitBtn = doc.getElementById('ProductSubmitButton-' + sectionId);
              if (submitBtn && newSubmitBtn) {
                submitBtn.disabled = newSubmitBtn.hasAttribute('disabled');
                submitBtn.textContent = newSubmitBtn.textContent;
              }
              const variantEl = newProductInfo.querySelector('variant-selects [data-selected-variant]');
              const variant = variantEl ? (function () { try { return JSON.parse(variantEl.textContent); } catch (e) { return null; } })() : null;
              if (variant && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: sectionId, html: doc, variant: variant } });
              }
            }).catch(function () {});
          }
        }
      }

      if (customInput) {
        customInput.addEventListener('input', function () {
          const selectedOpt = dropdown.querySelector('.ec-height-select__option--selected');
          if (selectedOpt && (selectedOpt.getAttribute('data-value') || '') === customHeightValue) {
            const val = customInput.value.trim();
            syncHeightToTarget(val);
            if (val) syncVariantFromHeight(val);
            if (labelElement) {
              labelElement.textContent = val || customHeightValue;
            }
          }
          document.dispatchEvent(new CustomEvent('product-form:validate'));
        });
        customInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            const selectedOpt = dropdown.querySelector('.ec-height-select__option--selected');
            if (selectedOpt && (selectedOpt.getAttribute('data-value') || '') === customHeightValue && customInput.value.trim()) {
              const val = customInput.value.trim();
              syncHeightToTarget(val);
              if (val) syncVariantFromHeight(val);
              if (labelElement) labelElement.textContent = val;
              document.dispatchEvent(new CustomEvent('product-form:validate'));
              const productForm = document.querySelector('product-form');
              if (productForm && productForm.isFormValid && productForm.isFormValid()) {
                const form = productForm.querySelector('form');
                if (form) form.requestSubmit();
              }
              closeHeightDropdown();
            }
          }
        });
      }

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          const value = option.getAttribute('data-value') || '';
          const text = option.textContent ? option.textContent.trim() : '';

          if (hiddenInput) {
            hiddenInput.value = value;
          }

          if (customWrapper && customInput) {
            if (value === customHeightValue) {
              customWrapper.style.display = 'block';
              syncHeightToTarget(customInput.value.trim());
            } else {
              customWrapper.style.display = 'none';
              customInput.value = '';
              syncHeightToTarget(value);
            }
          } else {
            syncHeightToTarget(value);
          }

          options.forEach(function (opt) {
            opt.classList.remove('ec-height-select__option--selected');
            opt.setAttribute('aria-selected', 'false');
          });

          if (value !== '') {
            option.classList.add('ec-height-select__option--selected');
            option.setAttribute('aria-selected', 'true');
            if (labelElement) {
              if (value === customHeightValue && customInput && customInput.value.trim()) {
                labelElement.textContent = customInput.value.trim();
              } else if (text) {
                labelElement.textContent = text;
              }
            }
          } else {
            option.setAttribute('aria-selected', 'true');
            if (labelElement && defaultLabel) {
              labelElement.textContent = defaultLabel;
            }
            if (customWrapper) customWrapper.style.display = 'none';
            if (customInput) customInput.value = '';
          }

          const valueForVariant = (value === customHeightValue && customInput) ? customInput.value.trim() : value;
          if (valueForVariant) syncVariantFromHeight(valueForVariant);
          if (value !== customHeightValue) {
            closeHeightDropdown();
          } else if (dropdown.classList.contains('ec-height-select--in-accordion')) {
            const optionEl = dropdown.querySelector('.ec-pdp-choose-option');
            if (optionEl && typeof refreshContentHeight === 'function') {
              requestAnimationFrame(function() { refreshContentHeight(optionEl); });
            }
            if (customInput) customInput.focus();
          }
          document.dispatchEvent(new CustomEvent('product-form:validate'));
        });
      });

      document.addEventListener('click', function (event) {
        if (!dropdown.contains(event.target)) {
          closeHeightDropdown();
        }
      });
    });

    function isMobile() {
      return window.innerWidth <= 768;
    }

    function getContentHeight(content) {
      if (content.closest('.ec-pdp-option-cards')) {
        return 50;
      }
      const previews = Array.from(content.querySelectorAll('.ec-pdp-choose-option__item-preview')).filter(function(p) {
        return !p.closest('.ec-pdp-choose-option__mobile-preview') && !p.closest('.ec-pdp-choose-option__selected-preview');
      });
      previews.forEach(function(p) { p.style.display = 'none'; });
      const originalTransition = content.style.transition;
      const originalHeight = content.style.height;
      content.style.transition = 'none';
      content.style.height = 'auto';
      const height = content.scrollHeight;
      content.style.height = originalHeight || '0px';
      content.offsetHeight;
      content.style.transition = originalTransition;
      previews.forEach(function(p) { p.style.display = ''; });
      return height;
    }

    function closeAccordion(optionElement) {
      const content = optionElement ? optionElement.querySelector('.ec-pdp-choose-option__content') : null;
      if (!content) return;
      content.style.height = '0px';
      content.style.opacity = '0';
      optionElement.classList.remove('expanded');
      const heightSelect = optionElement.closest('.ec-height-select--in-accordion');
      if (heightSelect) {
        heightSelect.classList.remove('ec-height-select--open');
        const tr = heightSelect.querySelector('.ec-height-select__trigger');
        if (tr) tr.setAttribute('aria-expanded', 'false');
      }
    }

    function openAccordion(optionElement) {
      const content = optionElement ? optionElement.querySelector('.ec-pdp-choose-option__content') : null;
      const title = optionElement ? optionElement.querySelector('.ec-pdp-choose-option__title') : null;
      if (!content) return;
      const currentHeight = getContentHeight(content);
      content.style.height = currentHeight + 'px';
      content.style.opacity = '1';
      optionElement.classList.add('expanded');
      if (title) {
        setTimeout(function() {
          title.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    }

    function getNextUnselectedOption(currentOption) {
      const allOptions = document.querySelectorAll('.ec-pdp-choose-option');
      let foundCurrent = false;
      for (var i = 0; i < allOptions.length; i++) {
        var opt = allOptions[i];
        if (opt.getAttribute('data-oc-role') === 'optional' || opt.classList.contains('ec-pdp-oc-block--optional')) continue;
        if (window.getComputedStyle(opt).display === 'none') continue;
        if (opt === currentOption) {
          foundCurrent = true;
          continue;
        }
        if (foundCurrent) {
          var hasSelected = opt.querySelector('.ec-pdp-choose-option__item.selected');
          if (!hasSelected) return opt;
        }
      }
      return null;
    }
    
    function refreshContentHeight(optionElement) {
      if (!optionElement || !optionElement.classList.contains('expanded')) return;
      const content = optionElement.querySelector('.ec-pdp-choose-option__content');
      if (!content) return;
      const height = getContentHeight(content);
      content.style.height = height + 'px';
    }

    function closeSelectedPreview(optionElement) {
      if (!optionElement) return;
      const container = optionElement.querySelector('.ec-pdp-choose-option__selected-preview');
      if (!container) return;
      container.classList.remove('active');
      container.innerHTML = '';
    }

    function updateSelectedPreview(optionElement, itemElement) {
      if (!optionElement) return;
      const container = optionElement.querySelector('.ec-pdp-choose-option__selected-preview');
      const content = optionElement.querySelector('.ec-pdp-choose-option__content');
      if (!container || !content) return;
      if (!itemElement) {
        closeSelectedPreview(optionElement);
        return;
      }
      const itemImage = itemElement.querySelector('.ec-pdp-choose-option__item-image');
      if (!itemImage) return;
      const clone = itemImage.cloneNode(true);
      clone.classList.add('selected');
      clone.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        itemElement.classList.remove('selected');
        closeSelectedPreview(optionElement);
        openAccordion(optionElement);
        document.dispatchEvent(new CustomEvent('product-form:validate'));
      });
      const wrapper = document.createElement('div');
      wrapper.className = 'ec-pdp-choose-option__selected-preview-swatches';
      wrapper.appendChild(clone);
      if (container.replaceChildren) {
        container.replaceChildren(wrapper);
      } else {
        container.innerHTML = '';
        container.appendChild(wrapper);
      }
      container.classList.add('active');
    }

    const expandedOptions = document.querySelectorAll('.ec-pdp-choose-option.expanded');
    expandedOptions.forEach(function(option) {
      const content = option.querySelector('.ec-pdp-choose-option__content');
      if (content) {
        const currentHeight = getContentHeight(content);
        content.style.height = currentHeight + 'px';
        content.style.opacity = '1';
      }
    });

    const chooseOptionTitles = document.querySelectorAll('.ec-pdp-choose-option__title');
    
    chooseOptionTitles.forEach(function(title) {
      if (title.closest('.ec-native-variant-chooser')) return;
      const option = title.closest('.ec-pdp-choose-option');
      const content = option ? option.querySelector('.ec-pdp-choose-option__content') : null;

      if (content) {
        title.addEventListener('click', function() {
          if (option.classList.contains('expanded')) {
            closeAccordion(option);
            document.dispatchEvent(new CustomEvent('product-form:validate'));
          } else {
            openAccordion(option);
            if (option.getAttribute('data-option-type') === 'height') {
              const heightSelect = option.closest('.ec-height-select');
              if (heightSelect && !heightSelect.classList.contains('ec-height-select--open')) {
                heightSelect.classList.add('ec-height-select--open');
                const trigger = heightSelect.querySelector('.ec-height-select__trigger');
                if (trigger) trigger.setAttribute('aria-expanded', 'true');
                if (typeof refreshContentHeight === 'function') {
                  requestAnimationFrame(function() { refreshContentHeight(option); });
                }
              }
            }
          }
        });
      }
    });

    const chooseOptionItems = document.querySelectorAll('.ec-pdp-choose-option__item');
    
    chooseOptionItems.forEach(function(item) {
      if (item.closest('.ec-native-variant-chooser')) return;
      const option = item.closest('.ec-pdp-choose-option');
      const content = option ? option.querySelector('.ec-pdp-choose-option__content') : null;
      const inlinePreview = item.querySelector('.ec-pdp-choose-option__item-preview');

      item.addEventListener('click', function () {
        if (item.closest('.ec-pdp-option-cards')) return;
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          if (option) closeSelectedPreview(option);
          document.dispatchEvent(new CustomEvent('product-form:validate'));
        } else {
          const allItemsInOption = option ? option.querySelectorAll('.ec-pdp-choose-option__item') : [];
          allItemsInOption.forEach(function(otherItem) {
            otherItem.classList.remove('selected');
          });
          this.classList.add('selected');
          if (option) {
            updateSelectedPreview(option, this);
            closeAccordion(option);
            const nextOption = getNextUnselectedOption(option);
            if (nextOption) openAccordion(nextOption);
          }
          document.dispatchEvent(new CustomEvent('product-form:validate'));
        }
      });

      if (inlinePreview) {
        item.addEventListener('mouseenter', function () {
          if (isMobile()) return;
          if (!content) return;
          var offsetTop = item.offsetTop + item.offsetHeight;
          inlinePreview.style.top = offsetTop + 'px';
        });

        item.addEventListener('mouseleave', function () {
          if (isMobile()) return;
          inlinePreview.style.top = '';
        });
      }
    });
    
    window.addEventListener('resize', function() {
      const allOptions = document.querySelectorAll('.ec-pdp-choose-option.expanded');
      allOptions.forEach(function(option) {
        refreshContentHeight(option);
      });
    });

    document.querySelectorAll('.ec-pdp-option-cards').forEach(function(wrapper) {
      var reqBlock = wrapper.querySelector('[data-oc-role="required"]');
      var optBlock = wrapper.querySelector('[data-oc-role="optional"]');
      if (!reqBlock || !optBlock) return;

      var selectedReqIdx = -1;
      var selectedOptIdx = -1;

      function ocGetOptionalDraftLine() {
        var cvOpt = optBlock.querySelector('.ec-pdp-oc__card-val');
        var svOpt = optBlock.querySelector('.ec-pdp-oc__size-val');
        var mod = cvOpt && cvOpt.value && String(cvOpt.value).trim();
        var dim = svOpt && svOpt.value && String(svOpt.value).trim();
        var sizesWrap = optBlock.querySelector('.ec-pdp-oc-sizes');
        var needsDim = sizesWrap && window.getComputedStyle(sizesWrap).display !== 'none';
        if (!mod) return null;
        if (needsDim && !dim) return null;
        return needsDim ? mod + ' — ' + dim : mod;
      }

      function ocRefreshCommittedOptionalList() {
        var am = wrapper.querySelector('.ec-pdp-oc__additional-modules-val');
        var host = wrapper.querySelector('.ec-pdp-oc-optional-committed-wrap');
        if (!host || !am) return;
        var lines = String(am.value || '').trim().split('\n').filter(function(l) { return l; });
        host.innerHTML = '';
        if (!lines.length) {
          host.style.display = 'none';
          return;
        }
        host.style.display = 'flex';
        lines.forEach(function(line) {
          var row = document.createElement('div');
          row.className = 'ec-pdp-oc-optional-committed-row';
          row.textContent = line;
          host.appendChild(row);
        });
      }

      function ocCommitOptionalLine() {
        var line = ocGetOptionalDraftLine();
        if (!line) return;
        var am = wrapper.querySelector('.ec-pdp-oc__additional-modules-val');
        if (!am) return;
        var cur = String(am.value || '').trim();
        am.value = cur ? cur + '\n' + line : line;
        selectedOptIdx = -1;
        ocDeselectBlock(optBlock);
        if (selectedReqIdx >= 0) {
          ocShowOptional(selectedReqIdx);
        } else {
          refreshContentHeight(optBlock);
        }
        ocRefreshCommittedOptionalList();
        document.dispatchEvent(new CustomEvent('product-form:validate'));
      }

      var reqContent = reqBlock.querySelector('.ec-pdp-choose-option__content');
      if (reqContent) {
        reqContent.style.height = '0px';
        reqContent.style.opacity = '0';
        reqBlock.classList.remove('expanded');
      }

      function ocUpdatePreview(block, itemEl) {
        var preview = block.querySelector('.ec-pdp-choose-option__selected-preview');
        if (!preview) return;
        if (!itemEl) {
          preview.classList.remove('active');
          preview.innerHTML = '';
          return;
        }
        var itemImage = itemEl.querySelector('.ec-pdp-choose-option__item-image');
        if (!itemImage) return;
        var clone = itemImage.cloneNode(true);
        clone.classList.add('selected');
        clone.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          itemEl.classList.remove('selected');
          preview.classList.remove('active');
          preview.innerHTML = '';
          openAccordion(block);
          var role = block.getAttribute('data-oc-role');
          if (role === 'required') {
            selectedReqIdx = -1;
            ocHideSizes(block);
            ocHideOptional();
          } else {
            selectedOptIdx = -1;
            ocHideSizes(block);
          }
          document.dispatchEvent(new CustomEvent('product-form:validate'));
        });
        var wrapper = document.createElement('div');
        wrapper.className = 'ec-pdp-choose-option__selected-preview-swatches';
        wrapper.appendChild(clone);
        if (preview.replaceChildren) {
          preview.replaceChildren(wrapper);
        } else {
          preview.innerHTML = '';
          preview.appendChild(wrapper);
        }
        preview.classList.add('active');
      }

      function ocShowSizes(block, sizes, cardName) {
        var sw = block.querySelector('.ec-pdp-oc-sizes');
        var sl = block.querySelector('.ec-pdp-oc-size-list');
        var cv = block.querySelector('.ec-pdp-oc__card-val');
        var trigger = block.querySelector('.ec-pdp-oc-size-trigger');
        var dropdown = block.querySelector('.ec-pdp-oc-size-dropdown');
        var label = block.querySelector('.ec-pdp-oc-size-label');
        if (!sw || !sl) return;
        if (cv) cv.value = cardName;
        if (label) label.textContent = 'Select';
        var sv = block.querySelector('.ec-pdp-oc__size-val');
        if (sv) sv.value = '';
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (dropdown) dropdown.style.display = 'none';
        sl.innerHTML = '';
        (sizes || []).forEach(function(size) {
          var li = document.createElement('li');
          li.className = 'ec-pdp-oc-size-option';
          li.textContent = size;
          li.addEventListener('click', function(e) {
            e.stopPropagation();
            sl.querySelectorAll('.ec-pdp-oc-size-option').forEach(function(o) { o.classList.remove('selected'); });
            li.classList.add('selected');
            if (sv) sv.value = size;
            if (label) label.textContent = size;
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            if (dropdown) dropdown.style.display = 'none';
            if (block.getAttribute('data-oc-role') === 'required') {
              ocShowOptional(selectedReqIdx);
            }
            if (block.getAttribute('data-oc-role') === 'optional') {
              ocCommitOptionalLine();
            }
            document.dispatchEvent(new CustomEvent('product-form:validate'));
          });
          sl.appendChild(li);
        });
        if ((sizes || []).length > 0) {
          sw.style.display = '';
          if (trigger) {
            trigger.onclick = function(e) {
              e.stopPropagation();
              var isOpen = trigger.getAttribute('aria-expanded') === 'true';
              trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
              if (dropdown) dropdown.style.display = isOpen ? 'none' : '';
              requestAnimationFrame(function() { refreshContentHeight(block); });
            };
          }
          requestAnimationFrame(function() { refreshContentHeight(block); });
        }
        if (block.getAttribute('data-oc-role') === 'optional' && (sizes || []).length === 0) {
          ocCommitOptionalLine();
        }
      }

      function ocHideSizes(block) {
        var sw = block.querySelector('.ec-pdp-oc-sizes');
        var cv = block.querySelector('.ec-pdp-oc__card-val');
        var sv = block.querySelector('.ec-pdp-oc__size-val');
        var trigger = block.querySelector('.ec-pdp-oc-size-trigger');
        var dropdown = block.querySelector('.ec-pdp-oc-size-dropdown');
        var label = block.querySelector('.ec-pdp-oc-size-label');
        if (sw) sw.style.display = 'none';
        if (cv) cv.value = '';
        if (sv) sv.value = '';
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (dropdown) dropdown.style.display = 'none';
        if (label) label.textContent = 'Select';
      }

      function ocDeselectBlock(block) {
        block.querySelectorAll('.ec-pdp-choose-option__item').forEach(function(c) { c.classList.remove('selected'); });
        ocUpdatePreview(block, null);
        ocHideSizes(block);
      }

      function ocShowOptional(excludeIdx) {
        optBlock.querySelectorAll('.ec-pdp-choose-option__item').forEach(function(card) {
          card.style.display = (parseInt(card.getAttribute('data-oc-index'), 10) === excludeIdx) ? 'none' : '';
        });
        if (selectedOptIdx === excludeIdx) {
          selectedOptIdx = -1;
          ocDeselectBlock(optBlock);
        }
        optBlock.style.display = '';
        if (!optBlock.classList.contains('expanded')) {
          var oc = optBlock.querySelector('.ec-pdp-choose-option__content');
          if (oc) {
            oc.style.height = getContentHeight(oc) + 'px';
            oc.style.opacity = '1';
          }
          optBlock.classList.add('expanded');
        } else {
          refreshContentHeight(optBlock);
        }
      }

      function ocHideOptional() {
        selectedOptIdx = -1;
        ocDeselectBlock(optBlock);
        var am = wrapper.querySelector('.ec-pdp-oc__additional-modules-val');
        if (am) am.value = '';
        var host = wrapper.querySelector('.ec-pdp-oc-optional-committed-wrap');
        if (host) {
          host.innerHTML = '';
          host.style.display = 'none';
        }
        var oc = optBlock.querySelector('.ec-pdp-choose-option__content');
        if (oc) { oc.style.height = '0px'; oc.style.opacity = '0'; }
        optBlock.classList.remove('expanded');
        optBlock.style.display = 'none';
        document.dispatchEvent(new CustomEvent('product-form:validate'));
      }

      function ocClearOptionalForNewMain() {
        selectedOptIdx = -1;
        ocDeselectBlock(optBlock);
        var am = wrapper.querySelector('.ec-pdp-oc__additional-modules-val');
        if (am) am.value = '';
        var host = wrapper.querySelector('.ec-pdp-oc-optional-committed-wrap');
        if (host) {
          host.innerHTML = '';
          host.style.display = 'none';
        }
        document.dispatchEvent(new CustomEvent('product-form:validate'));
      }

      reqBlock.querySelectorAll('.ec-pdp-choose-option__item').forEach(function(card) {
        card.addEventListener('click', function() {
          var idx = parseInt(card.getAttribute('data-oc-index'), 10);
          if (selectedReqIdx === idx) {
            selectedReqIdx = -1;
            ocDeselectBlock(reqBlock);
            ocHideOptional();
            refreshContentHeight(reqBlock);
            document.dispatchEvent(new CustomEvent('product-form:validate'));
            return;
          }
          if (selectedReqIdx >= 0 && selectedReqIdx !== idx) {
            ocClearOptionalForNewMain();
          }
          selectedReqIdx = idx;
          reqBlock.querySelectorAll('.ec-pdp-choose-option__item').forEach(function(c) { c.classList.remove('selected'); });
          card.classList.add('selected');
          ocUpdatePreview(reqBlock, card);
          var sizes = [];
          try { sizes = JSON.parse(card.getAttribute('data-oc-sizes') || '[]'); } catch(e) {}
          ocShowSizes(reqBlock, sizes, card.getAttribute('data-oc-name') || '');
          ocShowOptional(selectedReqIdx);
          refreshContentHeight(reqBlock);
          refreshContentHeight(optBlock);
          document.dispatchEvent(new CustomEvent('product-form:validate'));
        });
      });

      optBlock.querySelectorAll('.ec-pdp-choose-option__item').forEach(function(card) {
        card.addEventListener('click', function() {
          var idx = parseInt(card.getAttribute('data-oc-index'), 10);
          if (selectedOptIdx === idx) {
            selectedOptIdx = -1;
            ocDeselectBlock(optBlock);
            refreshContentHeight(optBlock);
            document.dispatchEvent(new CustomEvent('product-form:validate'));
            return;
          }
          selectedOptIdx = idx;
          optBlock.querySelectorAll('.ec-pdp-choose-option__item').forEach(function(c) { c.classList.remove('selected'); });
          card.classList.add('selected');
          ocUpdatePreview(optBlock, card);
          var sizes = [];
          try { sizes = JSON.parse(card.getAttribute('data-oc-sizes') || '[]'); } catch(e) {}
          ocShowSizes(optBlock, sizes, card.getAttribute('data-oc-name') || '');
          refreshContentHeight(optBlock);
          document.dispatchEvent(new CustomEvent('product-form:validate'));
        });
      });
    });

    function ecEscapeHtml(str) {
      if (str == null || str === '') return '';
      var el = document.createElement('div');
      el.textContent = String(str);
      return el.innerHTML;
    }

    function updateEcPdpOcSummary() {
      var summaryEl = document.getElementById('ec-pdp-oc-summary-{{ section.id }}');
      if (!summaryEl) return;
      var cards = document.getElementById('ec-pdp-option-cards-{{ section.id }}');
      var lm = summaryEl.getAttribute('data-label-module') || 'Module';
      var ld = summaryEl.getAttribute('data-label-dimension') || 'Dimension';
      var lad = summaryEl.getAttribute('data-label-additional-modules') || 'Additional modules';
      if (!cards) {
        summaryEl.innerHTML = '';
        return;
      }
      var rows = [];
      var req = cards.querySelector('[data-oc-role="required"]');
      if (req) {
        var cv = req.querySelector('.ec-pdp-oc__card-val');
        var sv = req.querySelector('.ec-pdp-oc__size-val');
        if (cv && cv.value && String(cv.value).trim()) {
          rows.push(
            '<div class="ec-pdp-oc-summary__row"><span class="ec-pdp-oc-summary__label">' +
              ecEscapeHtml(lm) +
              '</span> ' +
              ecEscapeHtml(cv.value.trim()) +
              '</div>'
          );
        }
        if (sv && sv.value && String(sv.value).trim()) {
          rows.push(
            '<div class="ec-pdp-oc-summary__row"><span class="ec-pdp-oc-summary__label">' +
              ecEscapeHtml(ld) +
              '</span> ' +
              ecEscapeHtml(sv.value.trim()) +
              '</div>'
          );
        }
      }
      var am = cards.querySelector('.ec-pdp-oc__additional-modules-val');
      if (am && am.value && String(am.value).trim()) {
        var lines = String(am.value).trim().split('\n');
        var multiline = lines.map(function (line) { return ecEscapeHtml(line); }).join('<br>');
        rows.push(
          '<div class="ec-pdp-oc-summary__row"><span class="ec-pdp-oc-summary__label">' +
            ecEscapeHtml(lad) +
            '</span> ' +
            multiline +
            '</div>'
        );
      }
      summaryEl.innerHTML = rows.join('');
    }

    document.querySelectorAll('.ec-native-variant-chooser').forEach(function(chooser) {
      var dataEl = document.getElementById('ec-nvc-data-' + chooser.getAttribute('data-block-id'));
      if (!dataEl) return;
      var nvcData;
      try { nvcData = JSON.parse(dataEl.textContent); } catch(e) { return; }

      var nvcBlockId   = nvcData.blockId;
      var nvcSectionId = nvcData.sectionId;
      var nvcProductId = nvcData.productId;
      var nvcOptions   = nvcData.options;
      var nvcVariants  = nvcData.variants;
      var nvcCartChangeUrl = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change';

      var nvcCardSection    = document.getElementById('ec-nvc-card-' + nvcBlockId);
      var nvcDropWrapper    = document.getElementById('ec-nvc-drop-' + nvcBlockId);
      var nvcOptStack       = document.getElementById('ec-nvc-optional-stack-' + nvcBlockId);
      var nvcOptSection     = nvcOptStack ? nvcOptStack.querySelector('.ec-nvc-optional-slot') : document.getElementById('ec-nvc-optional-' + nvcBlockId);
      var nvcOptCardSection = nvcOptSection ? nvcOptSection.querySelector('.ec-pdp-choose-option[data-oc-role="optional"]') : document.getElementById('ec-nvc-opt-card-' + nvcBlockId);
      var nvcOptDropWrapper = nvcOptSection ? nvcOptSection.querySelector('.ec-height-select.ec-height-select--in-accordion') : document.getElementById('ec-nvc-opt-drop-' + nvcBlockId);

      if (!chooser._ecNvcHeightToggleBound) {
        chooser._ecNvcHeightToggleBound = true;
        chooser.addEventListener('click', function(e) {
          var t = e.target.closest('.ec-height-select__trigger');
          if (!t || !chooser.contains(t)) return;
          var wrap = t.closest('.ec-height-select.ec-height-select--in-accordion');
          if (!wrap || !chooser.contains(wrap)) return;
          e.preventDefault();
          e.stopPropagation();
          var acc = wrap.querySelector('.ec-pdp-choose-option');
          var isOpen = wrap.classList.contains('ec-height-select--open');
          wrap.classList.toggle('ec-height-select--open', !isOpen);
          t.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (acc) requestAnimationFrame(function() { refreshContentHeight(acc); });
        });
      }

      var nvcActiveOptIdx    = null;
      var nvcOptActiveOptIdx   = null;
      var nvcSelections        = {};
      var nvcOptSelections     = {};
      var nvcOptAddedLineKeys  = [];
      var nvcOptIsAdding       = false;
      var nvcCommittedOptionals = [];
      var nvcReAddInProgress = false;
      var nvcStorageKey = 'ec_nvc_' + nvcProductId;
      var nvcGroupKey = 'ec_nvc_group_' + nvcProductId;

      // ID de grupo que vincula o item pai aos seus módulos opcionais no carrinho,
      // para que removendo o pai os opcionais daquele pai saiam junto.
      function nvcGetGroupId(createIfMissing) {
        var gid = '';
        try { gid = sessionStorage.getItem(nvcGroupKey) || ''; } catch (e) {}
        if (!gid && createIfMissing) {
          gid = 'g-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
          try { sessionStorage.setItem(nvcGroupKey, gid); } catch (e) {}
          nvcSyncGroupInput(gid);
        }
        return gid;
      }

      function nvcClearGroupId() {
        try { sessionStorage.removeItem(nvcGroupKey); } catch (e) {}
        nvcSyncGroupInput('');
      }

      // Mantém um input oculto no form do produto principal para que o item pai
      // seja gravado no carrinho com o mesmo _ec_nvc_group dos opcionais.
      function nvcSyncGroupInput(gid) {
        var f = nvcMainProductForm();
        if (!f) return;
        var input = f.querySelector('input[name="properties[_ec_nvc_group]"]');
        if (!gid) {
          if (input && input.parentNode) input.parentNode.removeChild(input);
          return;
        }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_ec_nvc_group]';
          f.appendChild(input);
        }
        input.value = gid;
      }

      function nvcSaveState() {
        try {
          sessionStorage.setItem(nvcStorageKey, JSON.stringify({ opts: nvcCommittedOptionals }));
        } catch (e) { }
      }

      function nvcClearSavedState() {
        try {
          sessionStorage.removeItem(nvcStorageKey);
        } catch (e) { }
      }

      function nvcLoadState() {
        try {
          var raw = sessionStorage.getItem(nvcStorageKey);
          if (!raw) return;
          var d = JSON.parse(raw);
          if (!d || !Array.isArray(d.opts) || !d.opts.length) return;
          var cleanedOpts = d.opts.filter(function (opt) { return opt && opt.variantId && opt.optModName; });
          if (!cleanedOpts.length) {
            nvcClearSavedState();
            return;
          }
          nvcCommittedOptionals = cleanedOpts;
          fetch('/cart.json')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var cartOptVariants = (cart.items || [])
                .filter(function (it) { return it.properties && (it.properties._ec_nvc_optional === '1' || it.properties._ec_nvc_optional === 1); })
                .map(function (it) { return it.variant_id; });
              var validOpts = nvcCommittedOptionals.filter(function (opt) {
                return cartOptVariants.indexOf(opt.variantId) !== -1;
              });
              if (validOpts.length !== nvcCommittedOptionals.length) {
                nvcCommittedOptionals = validOpts;
                if (validOpts.length) nvcSaveState();
                else nvcClearSavedState();
              }
            })
            .catch(function () { });
        } catch (e) { }
      }

      nvcLoadState();
      nvcSyncGroupInput(nvcGetGroupId(false));

      function nvcExtractLineKeyFromAddResponse(data) {
        if (!data) return null;
        if (data.key) return data.key;
        if (data.items && data.items.length === 1 && data.items[0].key) return data.items[0].key;
        return null;
      }

      function nvcLineItemInstanceId(it) {
        if (!it || !it.properties) return '';
        var p = it.properties;
        if (typeof p === 'object' && !Array.isArray(p)) {
          return String(p._ec_nvc_instance || '');
        }
        if (Array.isArray(p)) {
          for (var pi = 0; pi < p.length; pi++) {
            if (p[pi] && p[pi].name === '_ec_nvc_instance') return String(p[pi].value || '');
          }
        }
        return '';
      }

      function nvcFindLineKeyByInstance(data, variantId, instanceId) {
        if (!data || !data.items || !instanceId) return null;
        var vid = parseInt(variantId, 10);
        for (var i = data.items.length - 1; i >= 0; i--) {
          var it = data.items[i];
          if (parseInt(it.variant_id, 10) !== vid) continue;
          if (String(nvcLineItemInstanceId(it)) === String(instanceId)) return it.key;
        }
        return null;
      }

      function nvcFindLastLineKeyByVariant(data, variantId) {
        if (!data || !data.items) return null;
        var vid = parseInt(variantId, 10);
        for (var j = data.items.length - 1; j >= 0; j--) {
          if (parseInt(data.items[j].variant_id, 10) === vid) return data.items[j].key;
        }
        return null;
      }

      function nvcRemoveAllOptionalLines() {
        nvcCommittedOptionals = [];
        nvcClearSavedState();
        nvcClearGroupId();
        var keys = nvcOptAddedLineKeys.slice();
        nvcOptAddedLineKeys = [];
        var chain = keys.reduce(function (acc, key) {
          return acc.then(function () {
            return fetch(nvcCartChangeUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: String(key), quantity: 0 })
            }).catch(function() {});
          });
        }, Promise.resolve());
        return chain.then(function () {
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ec-optional-variant' });
          }
          if (nvcActiveOptIdx !== null) nvcShowOptional();
        });
      }

      function nvcApplyOptionalSlotIds(slotRoot, idSuffix) {
        slotRoot.id = 'ec-nvc-optional-' + idSuffix;
        var card = slotRoot.querySelector('.ec-pdp-choose-option[data-oc-role="optional"]');
        if (card) card.id = 'ec-nvc-opt-card-' + idSuffix;
        var drop = slotRoot.querySelector('.ec-height-select.ec-height-select--in-accordion');
        if (drop) drop.id = 'ec-nvc-opt-drop-' + idSuffix;
      }

      function nvcBindOptionalSlotTitle(cardSec) {
        if (!cardSec) return;
        var optTitle = cardSec.querySelector(':scope > .ec-pdp-choose-option__title');
        if (!optTitle || optTitle._nvcOptTitleBoundSlot) return;
        optTitle._nvcOptTitleBoundSlot = true;
        optTitle.addEventListener('click', function() {
          if (cardSec.classList.contains('expanded')) {
            closeAccordion(cardSec);
          } else {
            openAccordion(cardSec);
          }
        });
      }

      function nvcBindOptionalCardHover(slot) {
        if (!slot || slot._nvcHoverBound) return;
        slot._nvcHoverBound = true;
        slot.querySelectorAll('.ec-nvc-opt-card-item').forEach(function(card) {
          var inlinePreview = card.querySelector('.ec-pdp-choose-option__item-preview');
          if (!inlinePreview) return;
          card.addEventListener('mouseenter', function() {
            if (isMobile()) return;
            if (slot.classList.contains('ec-nvc-optional-slot--committed')) return;
            inlinePreview.style.top = (card.offsetTop + card.offsetHeight) + 'px';
          });
          card.addEventListener('mouseleave', function() {
            if (isMobile()) return;
            inlinePreview.style.top = '';
          });
        });
      }

      function nvcEnsureOptionalDelegation() {
        if (!nvcOptStack || nvcOptStack._nvcOptCardDelegation) return;
        nvcOptStack._nvcOptCardDelegation = true;
        nvcOptStack.addEventListener('click', function(e) {
          var card = e.target.closest('.ec-nvc-opt-card-item');
          if (!card || !nvcOptStack.contains(card)) return;
          var slot = card.closest('.ec-nvc-optional-slot');
          if (!slot || slot.classList.contains('ec-nvc-optional-slot--committed')) return;
          nvcOptSection = slot;
          nvcOptCardSection = slot.querySelector('.ec-pdp-choose-option[data-oc-role="optional"]');
          nvcOptDropWrapper = slot.querySelector('.ec-height-select.ec-height-select--in-accordion');

          var isExternal = card.getAttribute('data-nvc-external') === 'true';
          var externalId = card.getAttribute('data-nvc-product-id');
          var optIdx = parseInt(card.getAttribute('data-nvc-opt-idx'), 10);
          if (isNaN(optIdx)) optIdx = 0;

          var targetData = isExternal 
            ? (nvcData.externalModules || []).find(function(m) { return String(m.id) === String(externalId); })
            : { options: nvcNativeOptions, variants: nvcNativeVariants };

          if (slot._ecNvcActiveData !== targetData) {
            slot._ecNvcActiveData = targetData;
            nvcOptSelections = {};
          }

          var selectionKey = isExternal ? 'ext-' + externalId : optIdx;

          if (nvcOptActiveOptIdx === selectionKey && card.classList.contains('selected')) {
            nvcOptActiveOptIdx = null;
            card.classList.remove('selected');
            closeSelectedPreview(nvcOptCardSection);
            nvcHideOptDrop();
            document.dispatchEvent(new CustomEvent('product-form:validate'));
            return;
          }
          slot.querySelectorAll('.ec-nvc-opt-card-item').forEach(function(c) { c.classList.remove('selected'); });
          card.classList.add('selected');
          nvcOptActiveOptIdx = selectionKey;
          updateSelectedPreview(nvcOptCardSection, card);
          closeAccordion(nvcOptCardSection);
          nvcBuildOptDrop(optIdx);
        });
      }

      function nvcResetOptionalStack() {
        if (!nvcOptStack) return;
        var slots = nvcOptStack.querySelectorAll('.ec-nvc-optional-slot');
        for (var si = 1; si < slots.length; si++) {
          slots[si].remove();
        }
        var first = nvcOptStack.querySelector('.ec-nvc-optional-slot');
        if (!first) return;
        first.classList.remove('ec-nvc-optional-slot--committed');
        first.querySelectorAll(':scope > .ec-pdp-choose-option, :scope > .ec-height-select').forEach(function(el) {
          el.style.removeProperty('display');
        });
        nvcApplyOptionalSlotIds(first, nvcBlockId);
        first.querySelectorAll('.ec-nvc-opt-card-item').forEach(function(c) { c.classList.remove('selected'); });
        var c0 = first.querySelector('.ec-pdp-choose-option[data-oc-role="optional"]');
        if (c0) closeSelectedPreview(c0);
        var d0 = first.querySelector('.ec-height-select.ec-height-select--in-accordion');
        if (d0) {
          d0.style.display = 'none';
          d0.classList.remove('ec-height-select--open');
          var acc0 = d0.querySelector('.ec-pdp-choose-option');
          if (acc0) {
            acc0.classList.remove('expanded');
            var ct0 = acc0.querySelector('.ec-pdp-choose-option__content');
            if (ct0) { ct0.style.height = '0px'; ct0.style.opacity = '0'; }
          }
          var list0 = d0.querySelector('.ec-height-select__list');
          if (list0) list0.innerHTML = '<li class="ec-height-select__option ec-height-select__option--placeholder" data-value="" role="option" aria-selected="true">Select</li>';
          var dl0 = d0.querySelector('.ec-height-select__label');
          var di0 = d0.querySelector('.ec-height-select__input');
          if (dl0) dl0.textContent = '';
          if (di0) di0.value = '';
        }
        if (c0) {
          c0.classList.remove('expanded');
          var cc0 = c0.querySelector('.ec-pdp-choose-option__content');
          if (cc0) { cc0.style.height = '0px'; cc0.style.opacity = '0'; }
        }
        nvcOptSection = first;
        nvcOptCardSection = c0;
        nvcOptDropWrapper = d0;
        chooser._ecNvcOptSlotSeq = 0;
        delete first._nvcHoverBound;
        delete first._ecNvcActiveData;
      }

      function nvcSpawnNextOptionalSlot() {
        if (!nvcOptStack || !nvcOptSection) return;
        var activeSlot = nvcOptSection;

        var templateSlot = nvcOptStack.querySelector('.ec-nvc-optional-slot:not(.ec-nvc-optional-slot--committed)') || activeSlot;
        var newSlot = templateSlot.cloneNode(true);
        newSlot.classList.remove('ec-nvc-optional-slot--committed');

        newSlot.querySelectorAll('.ec-nvc-opt-card-item').forEach(function(c) { c.classList.remove('selected'); });

        chooser._ecNvcOptSlotSeq = (chooser._ecNvcOptSlotSeq || 0) + 1;
        var idSuffix = nvcBlockId + '-s' + chooser._ecNvcOptSlotSeq;
        nvcApplyOptionalSlotIds(newSlot, idSuffix);
        delete newSlot._nvcHoverBound;

        var newCardSec = newSlot.querySelector('.ec-pdp-choose-option[data-oc-role="optional"]');
        if (newCardSec) {
          closeSelectedPreview(newCardSec);
          newCardSec.classList.remove('expanded');
          var newCardContent = newCardSec.querySelector('.ec-pdp-choose-option__content');
          if (newCardContent) { newCardContent.style.height = '0px'; newCardContent.style.opacity = '0'; }
        }

        var newDrop = newSlot.querySelector('.ec-height-select.ec-height-select--in-accordion');
        if (newDrop) {
          newDrop.style.display = 'none';
          newDrop.classList.remove('ec-height-select--open');
          var dropAcc = newDrop.querySelector('.ec-pdp-choose-option');
          if (dropAcc) {
            dropAcc.classList.remove('expanded');
            var dropCt = dropAcc.querySelector('.ec-pdp-choose-option__content');
            if (dropCt) { dropCt.style.height = '0px'; dropCt.style.opacity = '0'; }
          }
          var tr = newDrop.querySelector('.ec-height-select__trigger');
          if (tr) tr.setAttribute('aria-expanded', 'false');
          var dl = newDrop.querySelector('.ec-height-select__label');
          var di = newDrop.querySelector('.ec-height-select__input');
          if (dl) dl.textContent = '';
          if (di) di.value = '';
          var clonedList = newDrop.querySelector('.ec-height-select__list');
          if (clonedList) clonedList.innerHTML = '<li class="ec-height-select__option ec-height-select__option--placeholder" data-value="" role="option" aria-selected="true">Select</li>';
        }

        activeSlot.classList.add('ec-nvc-optional-slot--committed');

        nvcOptStack.appendChild(newSlot);
        nvcOptSection = newSlot;
        nvcOptCardSection = newCardSec;
        nvcOptDropWrapper = newDrop;
        nvcOptSelections = {};
        nvcOptActiveOptIdx = null;

        nvcBindOptionalSlotTitle(newCardSec);
        nvcBindOptionalCardHover(newSlot);

        if (newCardSec) {
          void newCardSec.offsetHeight;
          openAccordion(newCardSec);
          requestAnimationFrame(function () { refreshContentHeight(newCardSec); });
        }

        document.dispatchEvent(new CustomEvent('product-form:validate'));
      }

      var nvcCardContent = nvcCardSection ? nvcCardSection.querySelector('.ec-pdp-choose-option__content') : null;
      if (nvcCardContent && nvcCardSection && nvcCardSection.classList.contains('expanded')) {
        nvcCardContent.style.height = getContentHeight(nvcCardContent) + 'px';
        nvcCardContent.style.opacity = '1';
      }

      var nvcCardTitle = nvcCardSection ? nvcCardSection.querySelector(':scope > .ec-pdp-choose-option__title') : null;
      if (nvcCardTitle) {
        nvcCardTitle.addEventListener('click', function() {
          if (nvcCardSection.classList.contains('expanded')) {
            closeAccordion(nvcCardSection);
          } else {
            openAccordion(nvcCardSection);
          }
        });
      }

      function nvcMainProductForm() {
        var productInfo = chooser.closest('product-info');
        if (!productInfo) return null;
        return productInfo.querySelector('#product-form-' + nvcSectionId);
      }

      function nvcMainVariantInput() {
        var f = nvcMainProductForm();
        return f ? f.querySelector('input[name="id"]') : null;
      }

      function nvcVariantFromForm() {
        var variantInput = nvcMainVariantInput();
        if (!variantInput) return null;
        var id = parseInt(variantInput.value, 10);
        if (isNaN(id)) return null;
        for (var vi = 0; vi < nvcVariants.length; vi++) {
          if (nvcVariants[vi].id === id) return nvcVariants[vi];
        }
        return null;
      }

      function nvcFullTargetOptions() {
        var cur = nvcVariantFromForm();
        var keys = ['option1', 'option2', 'option3'];
        var out = {};
        keys.forEach(function (key) {
          var s = nvcSelections[key];
          out[key] = (s != null && s !== '') ? s : (cur && cur[key] != null ? cur[key] : '') || '';
        });
        return out;
      }

      function nvcPrimaryTargetOptions() {
        if (!nvcOptions || !nvcOptions.length) return nvcFullTargetOptions();
        var firstKey = nvcOptions[0].key;
        var u = nvcSelections[firstKey];
        var cur = nvcVariantFromForm();
        if (u == null || u === '') u = cur && cur[firstKey] != null ? cur[firstKey] : '';
        if (!u) return nvcFullTargetOptions();
        var match = null;
        var matchUnavailable = null;
        for (var pi = 0; pi < nvcVariants.length; pi++) {
          var pv = nvcVariants[pi];
          if ((pv[firstKey] || '') !== (u || '')) continue;
          if (pv.available) {
            match = pv;
            break;
          }
          if (!matchUnavailable) matchUnavailable = pv;
        }
        if (!match) match = matchUnavailable;
        if (!match) return nvcFullTargetOptions();
        return {
          option1: match.option1 || '',
          option2: match.option2 || '',
          option3: match.option3 || ''
        };
      }

      function nvcConstraintOptions(optKey) {
        var cur = nvcVariantFromForm();
        var keys = ['option1', 'option2', 'option3'];
        var out = {};
        keys.forEach(function (key) {
          if (key === optKey) return;
          var s = nvcSelections[key];
          out[key] = (s != null && s !== '') ? s : (cur && cur[key] != null ? cur[key] : '') || '';
        });
        return out;
      }

      function nvcCommitVariant() {
        var target = nvcPrimaryTargetOptions();
        var optKeys = ['option1', 'option2', 'option3'];
        var match = null;
        var matchUnavailable = null;
        for (var i = 0; i < nvcVariants.length; i++) {
          var v = nvcVariants[i];
          var exact = optKeys.every(function (k) { return (v[k] || '') === (target[k] || ''); });
          if (!exact) continue;
          if (v.available) { match = v; break; }
          if (!matchUnavailable) matchUnavailable = v;
        }
        if (!match) match = matchUnavailable;
        if (!match) return;
        optKeys.forEach(function (k) {
          if (match[k]) nvcSelections[k] = match[k];
        });
        var productInfo = chooser.closest('product-info');
        if (!productInfo) return;

        var nvcForm = nvcMainProductForm();
        if (nvcForm && nvcOptions[0]) {
          var nvcModuleInput = nvcForm.querySelector('input[name="properties[_ec_nvc_module]"]');
          if (!nvcModuleInput) {
            nvcModuleInput = document.createElement('input');
            nvcModuleInput.type = 'hidden';
            nvcModuleInput.name = 'properties[_ec_nvc_module]';
            nvcForm.appendChild(nvcModuleInput);
          }
          nvcModuleInput.value = nvcOptions[0].name;
        }

        var variantInput = nvcMainVariantInput();
        if (!variantInput || parseInt(variantInput.value, 10) === match.id) return;
        variantInput.value = match.id;
        variantInput.removeAttribute('disabled');
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        var productUrl = productInfo.dataset.url;
        if (!productUrl) return;
        var url = productUrl + (productUrl.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + match.id + '&section_id=' + nvcSectionId;
        fetch(url).then(function(r) { return r.text(); }).then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['price', 'Sku', 'Inventory', 'Volume', 'Price-Per-Item'].forEach(function(id) {
            var s = doc.getElementById(id + '-' + nvcSectionId);
            var d = productInfo.querySelector('#' + id + '-' + nvcSectionId);
            if (s && d) d.innerHTML = s.innerHTML;
          });
          var btn = productInfo.querySelector('#ProductSubmitButton-' + nvcSectionId);
          var nb  = doc.getElementById('ProductSubmitButton-' + nvcSectionId);
          if (btn && nb) { btn.disabled = nb.hasAttribute('disabled'); btn.textContent = nb.textContent; }
        }).catch(function() {});
      }

      function nvcOpenDrop(optIdx) {
        if (!nvcDropWrapper) return;
        var opt      = nvcOptions[optIdx];
        var optKey   = opt.key;
        var optVals  = opt.values;

        var dropName     = nvcDropWrapper.querySelector('.ec-nvc-drop-name');
        var dropList     = nvcDropWrapper.querySelector('.ec-height-select__list');
        var dropTrigger  = nvcDropWrapper.querySelector('.ec-height-select__trigger');
        var dropLabel    = nvcDropWrapper.querySelector('.ec-height-select__label');
        var dropInput    = nvcDropWrapper.querySelector('.ec-height-select__input');
        var dropAccordion = nvcDropWrapper.querySelector('.ec-pdp-choose-option');
        if (!dropList) return;

        var ddReset = nvcDropWrapper.querySelector('.ec-height-select__dropdown');
        if (ddReset) ddReset.style.removeProperty('display');

        if (dropName)    dropName.textContent = opt.name;
        if (dropLabel)   dropLabel.textContent = nvcSelections[optKey] || '';
        if (dropInput)   dropInput.value = nvcSelections[optKey] || '';
        nvcDropWrapper.classList.remove('ec-height-select--open');
        if (dropTrigger) dropTrigger.setAttribute('aria-expanded', 'false');

        var avail = [];
        var constraints = nvcConstraintOptions(optKey);
        nvcVariants.forEach(function(v) {
          var okCons = true;
          for (var ck in constraints) {
            if ((v[ck] || '') !== (constraints[ck] || '')) { okCons = false; break; }
          }
          if (!okCons) return;
          if (optVals.indexOf(v[optKey]) === -1) return;
          if (v.available && avail.indexOf(v[optKey]) === -1) avail.push(v[optKey]);
        });

        dropList.innerHTML = '';
        var ph = document.createElement('li');
        ph.className = 'ec-height-select__option ec-height-select__option--placeholder';
        ph.setAttribute('data-value', ''); ph.setAttribute('role', 'option'); ph.setAttribute('aria-selected', 'true');
        ph.textContent = 'Select';
        dropList.appendChild(ph);

        optVals.forEach(function(val) {
          var unavail = avail.indexOf(val) === -1;
          var li = document.createElement('li');
          li.className = 'ec-height-select__option' + (unavail ? ' ec-height-select__option--unavailable' : '');
          if (nvcSelections[optKey] === val) li.classList.add('ec-height-select__option--selected');
          li.setAttribute('data-value', val); li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', nvcSelections[optKey] === val ? 'true' : 'false');
          li.textContent = val;
          if (!unavail) {
            li.addEventListener('click', function(e) {
              e.stopPropagation();
              nvcSelections[optKey] = val;
              dropList.querySelectorAll('.ec-height-select__option').forEach(function(o) {
                o.classList.remove('ec-height-select__option--selected');
                o.setAttribute('aria-selected', 'false');
              });
              li.classList.add('ec-height-select__option--selected');
              li.setAttribute('aria-selected', 'true');
              if (dropLabel)   dropLabel.textContent = val;
              if (dropInput)   dropInput.value = val;
              nvcDropWrapper.classList.remove('ec-height-select--open');
              var trSel = nvcDropWrapper.querySelector('.ec-height-select__trigger');
              if (trSel) trSel.setAttribute('aria-expanded', 'false');
              nvcCommitVariant();
              nvcShowOptional();
              document.dispatchEvent(new CustomEvent('product-form:validate'));
              if (dropAccordion) requestAnimationFrame(function() { refreshContentHeight(dropAccordion); });
            });
          }
          dropList.appendChild(li);
        });

        nvcDropWrapper.style.display = '';
        if (dropAccordion && !dropAccordion.classList.contains('expanded')) {
          var dc = dropAccordion.querySelector('.ec-pdp-choose-option__content');
          if (dc) { dc.style.height = getContentHeight(dc) + 'px'; dc.style.opacity = '1'; }
          dropAccordion.classList.add('expanded');
        }
        nvcDropWrapper.classList.add('ec-height-select--open');
        if (dropTrigger) dropTrigger.setAttribute('aria-expanded', 'true');
        nvcShowOptional();
        requestAnimationFrame(function () {
          if (dropAccordion) refreshContentHeight(dropAccordion);
          if (nvcOptCardSection) refreshContentHeight(nvcOptCardSection);
        });
      }

      function nvcHideDrop() {
        if (!nvcDropWrapper) return;
        var da = nvcDropWrapper.querySelector('.ec-pdp-choose-option');
        if (da) closeAccordion(da);
        var dl = nvcDropWrapper.querySelector('.ec-height-select__label');
        var di = nvcDropWrapper.querySelector('.ec-height-select__input');
        if (dl) dl.textContent = '';
        if (di) di.value = '';
        nvcDropWrapper.classList.remove('ec-height-select--open');
        nvcDropWrapper.style.display = 'none';
      }

      function nvcBuildOptDrop(optIdx) {
        if (!nvcOptDropWrapper || !nvcOptSection) return;
        var activeData = nvcOptSection._ecNvcActiveData || { options: nvcNativeOptions, variants: nvcNativeVariants };
        var opt      = activeData.options[optIdx];
        var optKey   = opt.key;
        var optVals  = opt.values;

        var dropName     = nvcOptDropWrapper.querySelector('.ec-nvc-drop-name');
        var dropList     = nvcOptDropWrapper.querySelector('.ec-height-select__list');
        var dropTrigger  = nvcOptDropWrapper.querySelector('.ec-height-select__trigger');
        var dropLabel    = nvcOptDropWrapper.querySelector('.ec-height-select__label');
        var dropInput    = nvcOptDropWrapper.querySelector('.ec-height-select__input');
        var dropAccordion = nvcOptDropWrapper.querySelector('.ec-pdp-choose-option');
        if (!dropList) return;

        var ddOptReset = nvcOptDropWrapper.querySelector('.ec-height-select__dropdown');
        if (ddOptReset) ddOptReset.style.removeProperty('display');

        if (dropName)    dropName.textContent = opt.name;
        if (dropLabel)   dropLabel.textContent = nvcOptSelections[optKey] || '';
        if (dropInput)   dropInput.value = nvcOptSelections[optKey] || '';
        nvcOptDropWrapper.classList.remove('ec-height-select--open');
        if (dropTrigger) dropTrigger.setAttribute('aria-expanded', 'false');

        var avail = [];
        activeData.variants.forEach(function(v) {
          if (optVals.indexOf(v[optKey]) !== -1 && v.available && avail.indexOf(v[optKey]) === -1) avail.push(v[optKey]);
        });

        dropList.innerHTML = '';
        var ph = document.createElement('li');
        ph.className = 'ec-height-select__option ec-height-select__option--placeholder';
        ph.setAttribute('data-value', ''); ph.setAttribute('role', 'option'); ph.setAttribute('aria-selected', 'true');
        ph.textContent = 'Select';
        dropList.appendChild(ph);

        optVals.forEach(function(val) {
          var unavail = avail.indexOf(val) === -1;
          var li = document.createElement('li');
          li.className = 'ec-height-select__option' + (unavail ? ' ec-height-select__option--unavailable' : '');
          if (nvcOptSelections[optKey] === val) li.classList.add('ec-height-select__option--selected');
          li.setAttribute('data-value', val); li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', nvcOptSelections[optKey] === val ? 'true' : 'false');
          li.textContent = val;
          if (!unavail) {
            li.addEventListener('click', function(e) {
              e.stopPropagation();
              nvcOptSelections[optKey] = val;
              dropList.querySelectorAll('.ec-height-select__option').forEach(function(o) {
                o.classList.remove('ec-height-select__option--selected');
                o.setAttribute('aria-selected', 'false');
              });
              li.classList.add('ec-height-select__option--selected');
              li.setAttribute('aria-selected', 'true');
              if (dropLabel)   dropLabel.textContent = val;
              if (dropInput)   dropInput.value = val;
              nvcOptDropWrapper.classList.remove('ec-height-select--open');
              var trOptSel = nvcOptDropWrapper.querySelector('.ec-height-select__trigger');
              if (trOptSel) trOptSel.setAttribute('aria-expanded', 'false');

              var primaryVariantId = null;
              var primaryProductInfo = chooser.closest('product-info');
              if (primaryProductInfo) {
                var pForm = primaryProductInfo.querySelector('#product-form-' + nvcSectionId);
                var pvi = pForm ? pForm.querySelector('input[name="id"]') : null;
                if (pvi) primaryVariantId = parseInt(pvi.value, 10);
              }


              var optMatch = null;
              for (var oi = 0; oi < activeData.variants.length; oi++) {
                var ov = activeData.variants[oi];
                if (ov.id === primaryVariantId) continue;
                var oOk = true;
                for (var ok in nvcOptSelections) {
                  if (nvcOptSelections[ok] && ov[ok] !== nvcOptSelections[ok]) { oOk = false; break; }
                }
                if (oOk && ov.available) { optMatch = ov; break; }
              }
              if (!optMatch) {
                for (var oj = 0; oj < activeData.variants.length; oj++) {
                  var ovv = activeData.variants[oj];
                  if (ovv.id === primaryVariantId) continue;
                  var oOkk = true;
                  for (var okk in nvcOptSelections) {
                    if (nvcOptSelections[okk] && ovv[okk] !== nvcOptSelections[okk]) { oOkk = false; break; }
                  }
                  if (oOkk) { optMatch = ovv; break; }
                }
              }


              if (optMatch && !nvcOptIsAdding) {
                nvcOptIsAdding = true;
                var nvcOptInstanceId = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
                var nvcOptGroupId = nvcGetGroupId(true);
                var optModName = '';
                if (String(nvcOptActiveOptIdx).indexOf('ext-') === 0) {
                   optModName = activeData.title || '';
                } else {
                   optModName = activeData.options[nvcOptActiveOptIdx] ? activeData.options[nvcOptActiveOptIdx].name : '';
                }
                fetch('/cart/add.json', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                  body: JSON.stringify({
                    items: [{
                      id: optMatch.id,
                      quantity: 1,
                      properties: {
                        '_ec_nvc_module': optModName,
                        '_ec_nvc_optional': '1',
                        '_ec_nvc_group': nvcOptGroupId,
                        '_ec_nvc_instance': nvcOptInstanceId
                      }
                    }]
                  })
                })
                  .then(function(r) { return r.json(); })
                  .then(function(response) {
                    nvcOptIsAdding = false;
                    if (response && response.status) {
                      return;
                    }
                    var lineKey = nvcFindLineKeyByInstance(response, optMatch.id, nvcOptInstanceId) || nvcFindLastLineKeyByVariant(response, optMatch.id) || nvcExtractLineKeyFromAddResponse(response);
                    if (lineKey) nvcOptAddedLineKeys.push(lineKey);
                    var existingOptIdx = -1;
                    for (var eci = 0; eci < nvcCommittedOptionals.length; eci++) {
                      if (nvcCommittedOptionals[eci].optModName === optModName) {
                        existingOptIdx = eci;
                        break;
                      }
                    }
                    if (existingOptIdx !== -1) {
                      nvcCommittedOptionals[existingOptIdx] = { variantId: optMatch.id, optModName: optModName };
                    } else if (optModName) {
                      nvcCommittedOptionals.push({ variantId: optMatch.id, optModName: optModName });
                    }
                    nvcSaveState();
                    nvcSpawnNextOptionalSlot();
                    try {
                      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ec-optional-variant' });
                      }
                    } catch(pubErr) {}
                  })
                  .catch(function() {
                    nvcOptIsAdding = false;
                  });
              }

              document.dispatchEvent(new CustomEvent('product-form:validate'));
              if (dropAccordion) requestAnimationFrame(function() { refreshContentHeight(dropAccordion); });
            });
          }
          dropList.appendChild(li);
        });

        nvcOptDropWrapper.style.display = '';
        if (dropAccordion && !dropAccordion.classList.contains('expanded')) {
          var dc = dropAccordion.querySelector('.ec-pdp-choose-option__content');
          if (dc) { dc.style.height = getContentHeight(dc) + 'px'; dc.style.opacity = '1'; }
          dropAccordion.classList.add('expanded');
        }
        nvcOptDropWrapper.classList.add('ec-height-select--open');
        if (dropTrigger) dropTrigger.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function() { if (dropAccordion) refreshContentHeight(dropAccordion); });
      }

      function nvcHideOptDrop() {
        if (!nvcOptDropWrapper) return;
        var da = nvcOptDropWrapper.querySelector('.ec-pdp-choose-option');
        if (da) closeAccordion(da);
        var dl = nvcOptDropWrapper.querySelector('.ec-height-select__label');
        var di = nvcOptDropWrapper.querySelector('.ec-height-select__input');
        if (dl) dl.textContent = '';
        if (di) di.value = '';
        nvcOptDropWrapper.classList.remove('ec-height-select--open');
        nvcOptDropWrapper.style.display = 'none';
      }

      function nvcShowOptional() {
        if (!nvcOptSection && !nvcOptStack) return;
        nvcEnsureOptionalDelegation();
        var activeSlot = nvcOptSection;
        if (nvcOptStack) {
          var slots = nvcOptStack.querySelectorAll('.ec-nvc-optional-slot');
          for (var si = slots.length - 1; si >= 0; si--) {
            if (!slots[si].classList.contains('ec-nvc-optional-slot--committed')) {
              activeSlot = slots[si];
              break;
            }
          }
          if (!activeSlot) activeSlot = nvcOptStack.querySelector('.ec-nvc-optional-slot:last-of-type');
          nvcOptSection = activeSlot;
          nvcOptCardSection = activeSlot ? activeSlot.querySelector('.ec-pdp-choose-option[data-oc-role="optional"]') : null;
          nvcOptDropWrapper = activeSlot ? activeSlot.querySelector('.ec-height-select.ec-height-select--in-accordion') : null;
          nvcOptStack.style.removeProperty('display');
        } else if (nvcOptSection) {
          nvcOptSection.style.removeProperty('display');
        }
        if (!nvcOptCardSection) return;
        var oc = nvcOptCardSection.querySelector('.ec-pdp-choose-option__content');
        if (oc) {
          if (!nvcOptCardSection.classList.contains('expanded')) {
            oc.style.height = getContentHeight(oc) + 'px';
            oc.style.opacity = '1';
            nvcOptCardSection.classList.add('expanded');
          } else {
            oc.style.opacity = '1';
            requestAnimationFrame(function() { refreshContentHeight(nvcOptCardSection); });
          }
        }
        nvcBindOptionalSlotTitle(nvcOptCardSection);
        if (nvcOptSection) nvcBindOptionalCardHover(nvcOptSection);
      }

      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && !chooser._ecNvcCartSubscribeBound) {
        chooser._ecNvcCartSubscribeBound = true;
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
          if (!data || data.source !== 'product-form' || data.productVariantId == null) return;
          var pi = chooser.closest('product-info');
          var formEl = nvcMainProductForm();
          if (!pi || !formEl || !pi.contains(formEl)) return;
          var mainEl = nvcMainVariantInput();
          if (!mainEl) return;
          var mainVid = parseInt(mainEl.value, 10);
          var evtVid = parseInt(data.productVariantId, 10);
          if (isNaN(mainVid) || mainVid !== evtVid) return;
          if (!nvcCommittedOptionals.length || nvcReAddInProgress) return;
          nvcReAddInProgress = true;
          fetch('/cart.json')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var hasMain = (cart.items || []).some(function (it) { return it.variant_id === mainVid; });
              if (!hasMain) {
                nvcReAddInProgress = false;
                return;
              }
              var existingOptVariants = (cart.items || [])
                .filter(function (it) { return it.properties && (it.properties._ec_nvc_optional === '1' || it.properties._ec_nvc_optional === 1); })
                .map(function (it) { return it.variant_id; });
              var seenIds = {};
              var missing = nvcCommittedOptionals.filter(function (opt) {
                if (!opt.variantId || !opt.optModName) return false;
                if (seenIds[opt.variantId]) return false;
                if (existingOptVariants.indexOf(opt.variantId) !== -1) return false;
                seenIds[opt.variantId] = true;
                return true;
              });
              if (!missing.length) {
                nvcReAddInProgress = false;
                return;
              }
              nvcOptAddedLineKeys = [];
              var reGroupId = nvcGetGroupId(true);
              var pending = missing.length;
              function doneOne() {
                pending--;
                if (pending <= 0) {
                  nvcReAddInProgress = false;
                  nvcShowOptional();
                  try {
                    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ec-optional-variant' });
                    }
                  } catch (pubErr) { }
                }
              }
              missing.forEach(function (opt) {
                var reInstanceId = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
                fetch('/cart/add.json', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                  body: JSON.stringify({
                    items: [{
                      id: opt.variantId,
                      quantity: 1,
                      properties: {
                        '_ec_nvc_module': opt.optModName,
                        '_ec_nvc_optional': '1',
                        '_ec_nvc_group': reGroupId,
                        '_ec_nvc_instance': reInstanceId
                      }
                    }]
                  })
                })
                  .then(function (r) { return r.json(); })
                  .then(function (response) {
                    if (response && response.status) {
                      doneOne();
                      return;
                    }
                    var lk = nvcFindLineKeyByInstance(response, opt.variantId, reInstanceId) || nvcFindLastLineKeyByVariant(response, opt.variantId) || nvcExtractLineKeyFromAddResponse(response);
                    if (lk) nvcOptAddedLineKeys.push(lk);
                    doneOne();
                  })
                  .catch(function () { doneOne(); });
              });
            })
            .catch(function () { nvcReAddInProgress = false; });
        });
      }

      var nvcNativeOptions  = nvcData.options;
      var nvcNativeVariants = nvcData.variants;
      var nvcNativeUrl      = nvcData.productUrl;

      chooser.querySelectorAll('.ec-nvc-card-item').forEach(function(card) {
        var inlinePreview = card.querySelector('.ec-pdp-choose-option__item-preview');

        card.addEventListener('click', function() {
          var isExternal = card.getAttribute('data-nvc-external') === 'true';
          var externalId = card.getAttribute('data-nvc-product-id');
          
          if (isExternal) {
            var extData = (nvcData.externalModules || []).find(function(m) { return String(m.id) === String(externalId); });
            if (extData) {
              if (nvcActiveOptIdx !== 'ext-' + externalId) nvcSelections = {};
              nvcOptions = extData.options;
              nvcVariants = extData.variants;
              var pi = chooser.closest('product-info');
              if (pi) pi.dataset.url = extData.url;
            }
          } else {
            if (nvcActiveOptIdx !== optIdx) nvcSelections = {};
            nvcOptions = nvcNativeOptions;
            nvcVariants = nvcNativeVariants;
            var pi2 = chooser.closest('product-info');
            if (pi2) pi2.dataset.url = nvcNativeUrl;
          }

          var optIdx = parseInt(card.getAttribute('data-nvc-opt-idx'), 10);
          if (isNaN(optIdx)) optIdx = 0; // External modules default to first option

          if (nvcActiveOptIdx === (isExternal ? 'ext-' + externalId : optIdx)) {
            nvcActiveOptIdx = null;
            card.classList.remove('selected');
            closeSelectedPreview(nvcCardSection);
            nvcHideDrop();
            if (nvcOptStack) {
              nvcOptStack.style.display = 'none';
              nvcResetOptionalStack();
            } else if (nvcOptSection) {
              nvcOptSection.style.display = 'none';
            }
            nvcOptActiveOptIdx = null; nvcOptSelections = {};
            nvcRemoveAllOptionalLines();
            document.dispatchEvent(new CustomEvent('product-form:validate'));
            return;
          }

          function nvcApplyMainModuleSelection() {
            chooser.querySelectorAll('.ec-nvc-card-item').forEach(function (c) { c.classList.remove('selected'); });
            card.classList.add('selected');
            nvcActiveOptIdx = isExternal ? 'ext-' + externalId : optIdx;
            updateSelectedPreview(nvcCardSection, card);
            closeAccordion(nvcCardSection);
            nvcOpenDrop(optIdx);
          }

          if (nvcActiveOptIdx !== null && nvcActiveOptIdx !== (isExternal ? 'ext-' + externalId : optIdx)) {
            nvcRemoveAllOptionalLines().then(function () {
              if (nvcOptStack) nvcResetOptionalStack();
              nvcApplyMainModuleSelection();
            });
            return;
          }

          nvcApplyMainModuleSelection();
        });

        if (inlinePreview) {
          card.addEventListener('mouseenter', function() {
            if (isMobile()) return;
            inlinePreview.style.top = (card.offsetTop + card.offsetHeight) + 'px';
          });
          card.addEventListener('mouseleave', function() {
            if (isMobile()) return;
            inlinePreview.style.top = '';
          });
        }
      });
    });

    document.addEventListener('product-form:validate', updateEcPdpOcSummary);
    updateEcPdpOcSummary();

    // ec-icon-text: transforma a palavra configurada na descrição em link que abre o iframe num modal
    (function initEcIconTextIframe() {
      const blocks = document.querySelectorAll('.ec-icon-text');
      if (!blocks.length) return;

      const modal = document.querySelector('[id^="ec-icon-text-iframe-modal"]');
      if (!modal) return;
      const modalBody = modal.querySelector('.ec-iframe-modal__body');
      const modalClose = modal.querySelector('.ec-iframe-modal__close');
      const modalOverlay = modal.querySelector('.ec-iframe-modal__overlay');

      function openModal(html) {
        modalBody.innerHTML = html;
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function closeModal() {
        modal.setAttribute('aria-hidden', 'true');
        modalBody.innerHTML = '';
        document.body.style.overflow = '';
      }
      if (modalClose) modalClose.addEventListener('click', closeModal);
      if (modalOverlay) modalOverlay.addEventListener('click', closeModal);

      function wrapWord(desc, word, tpl) {
        const needle = (word || '').trim().toLowerCase();
        if (!needle) return;
        const walker = document.createTreeWalker(desc, NodeFilter.SHOW_TEXT, null);
        let node;
        while ((node = walker.nextNode())) {
          const idx = node.nodeValue.toLowerCase().indexOf(needle);
          if (idx === -1) continue;
          const before = node.nodeValue.slice(0, idx);
          const match = node.nodeValue.slice(idx, idx + needle.length);
          const after = node.nodeValue.slice(idx + needle.length);
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ec-icon-iframe-trigger';
          btn.textContent = match;
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            openModal(tpl.innerHTML);
          });
          const frag = document.createDocumentFragment();
          if (before) frag.appendChild(document.createTextNode(before));
          frag.appendChild(btn);
          if (after) frag.appendChild(document.createTextNode(after));
          node.parentNode.replaceChild(frag, node);
          return; // só a primeira ocorrência
        }
      }

      blocks.forEach(function (block) {
        const desc = block.querySelector('.ec-icon-text__description[data-ec-iframe-word]');
        const tpl = block.querySelector('.ec-icon-text__iframe-content');
        if (!desc || !tpl) return;
        wrapWord(desc, desc.getAttribute('data-ec-iframe-word'), tpl);
      });
    })();
  });